import apiClient from "./apiClient";

export interface ItemDetail {
  id: string;
  company_id: string;
  sku: string;
  name: string;
  description?: string | null;
  category_id?: string | null;
  outlet_id?: string | null;
  vat_rate_id?: string | null;
  barcode?: string | null;
  qty?: number;
  stock_alert_threshold?: number | null;
  is_stock_alert?: boolean;
  purchase_price_minor?: number | null;
  unit_price_minor?: number | null;
  currency?: string;
  is_archived?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface UpdateItemPayload {
  name?: string;
  description?: string | null;
  category_id?: string | null;
  outlet_id?: string | null;
  vat_rate_id?: string | null;
  barcode?: string | null;
  qty?: number;
  stock_alert_threshold?: number | null;
  purchase_price_minor?: number | null;
  unit_price_minor?: number | null;
}

export interface ItemMonthlySalesPoint {
  month: string;
  revenue_minor: number;
}

export interface ItemStatsPayload {
  revenue_total_minor: number;
  margin_unit_minor: number | null;
  margin_total_minor: number;
  monthly_sales: ItemMonthlySalesPoint[];
}

export interface StockAlertsSummaryPayload {
  count: number;
}

export async function getItem(
  companyId: string,
  itemId: string,
): Promise<ItemDetail> {
  const response = await apiClient.get(
    `/api/companies/${companyId}/items/${itemId}`,
  );
  return response.item as ItemDetail;
}

export async function updateItem(
  companyId: string,
  itemId: string,
  payload: UpdateItemPayload,
): Promise<ItemDetail> {
  const response = await apiClient.patch(
    `/api/companies/${companyId}/items/${itemId}`,
    payload,
  );
  return response.item as ItemDetail;
}

export async function getItemStats(
  companyId: string,
  itemId: string,
): Promise<ItemStatsPayload> {
  const response = await apiClient.get(
    `/api/companies/${companyId}/items/${itemId}/stats`,
  );
  return response.stats as ItemStatsPayload;
}

export async function getStockAlertsSummary(
  companyId: string,
): Promise<StockAlertsSummaryPayload> {
  const response = await apiClient.get(
    `/api/companies/${companyId}/items/stock-alerts/summary`,
  );
  return response as StockAlertsSummaryPayload;
}

const itemsService = {
  getItem,
  updateItem,
  getItemStats,
  getStockAlertsSummary,
};

export default itemsService;
